import React from 'react';
import './Projects.css';
import funerariaImage from '../../assets/funeraria-monteros.webp';
import numeroSecretoImage from '../../assets/numero-secreto.webp';
import bolsaImage from '../../assets/bolsa-trabajo.webp';
import laVanguardiaImage from '../../assets/la-vanguardia.webp';
import esquivelImage from '../../assets/esquivel.webp';
import elBanqueteImage from '../../assets/elbanquete.webp';
import elaineSystemImage from '../../assets/elainesystem.webp';
import insQnvibesImage from '../../assets/ins-qnvibes.webp';
import qnvibesImage from '../../assets/qnvibes.webp';
import vectorImage from '../../assets/vector-com-sv.webp';
import treearchImage from '../../assets/treearch.webp';
import sivarcoImage from '../../assets/sivarco-nosotros.webp';

const projectData = [
  {
    title: 'La Vanguardia E-commerce',
    description: 'E-commerce de ropa con catálogo por categorías, gestión de carrito, proceso de compra y experiencia enfocada en conversión.',
    tags: ['React', 'Node.js', 'Express', 'MySQL'],
    image: laVanguardiaImage,
    liveUrl: 'https://la-vanguardia-ecommerce-h9ef.vercel.app/',
    sourceUrl: 'https://github.com/Duartemario501/La-vanguardia.ecommerce',
  },
  {
    title: 'Bolsa de Empleo',
    description: 'Plataforma de intermediación laboral donde empresas publican vacantes y candidatos aplican con un flujo de búsqueda y filtrado.',
    tags: ['Laravel', 'Vue.js', 'MySQL'],
    image: bolsaImage,
    liveUrl: 'https://bolsa-de-trabajos.vercel.app/landing',
    sourceUrl: 'https://github.com/Duartemario501/Bolsa_de_Trabajos',
  },
  {
    title: 'ERP de Recursos Humanos',
    description: 'Sistema interno para RRHH que centraliza expediente de empleados, control de vacaciones y seguimiento de procesos administrativos.',
    tags: ['PHP', 'MySQL', 'Bootstrap', 'JavaScript'],
    image: esquivelImage,
    liveUrl: 'https://esquivel.great-site.net/',
    sourceUrl: 'https://github.com/Duartemario501/Esquivel-RH',
  },
  {
    title: 'Sistema Contable Empresarial',
    description: 'Aplicación contable para registrar movimientos financieros, controlar facturación y generar reportes para toma de decisiones.',
    tags: ['PHP', 'MySQL', 'Bootstrap'],
    image: elBanqueteImage,
    liveUrl: 'https://elbanquete.great-site.net/',
    sourceUrl: 'https://github.com/segovia99/elbanquete',
  },
  {
    title: 'Sitio Web Funeraria Monteros',
    description: 'Sitio corporativo para presentar servicios funerarios, facilitar contacto directo y mejorar la presencia digital del negocio.',
    tags: ['TypeScript', 'React', 'CSS'],
    image: funerariaImage,
    liveUrl: 'https://funerariamonteros24.vercel.app/',
    sourceUrl: 'https://github.com/Duartemario501/Funeraria-Monteros',
  },
  {
    title: 'Juego Número Secreto',
    description: 'Proyecto práctico de lógica en JavaScript para adivinar un número secreto, con validaciones y retroalimentación al usuario.',
    tags: ['JavaScript', 'HTML', 'CSS'],
    image: numeroSecretoImage,
    liveUrl: 'https://numero-secreto-six-delta.vercel.app/',
    sourceUrl: 'https://github.com/Duartemario501/numeroSecreto',
  },
  {
    title: 'Elaine System',
    description: 'Sitio web corporativo orientado a posicionamiento digital de marca, presentación de servicios y canal de contacto comercial.',
    tags: ['Proyecto Real', 'Web'],
    image: elaineSystemImage,
    liveUrl: 'https://www.elainesystem.com',
    sourceUrl: null,
  },
  {
    title: 'QnVibes INS',
    description: 'Plataforma de culturización empresarial para comunicar lineamientos internos, fortalecer cultura organizacional y alinear equipos.',
    tags: ['Proyecto Real', 'Landing'],
    image: insQnvibesImage,
    liveUrl: 'https://ins.qnvibes.com',
    sourceUrl: null,
  },
  {
    title: 'QnVibes',
    description: 'Portal principal de la marca QnVibes para presentar su propuesta de valor, servicios y presencia comercial en línea.',
    tags: ['Proyecto Real', 'Brand Site'],
    image: qnvibesImage,
    liveUrl: 'https://qnvibes.com',
    sourceUrl: null,
  },
  {
    title: 'Vector',
    description: 'Página publicitaria empresarial diseñada para comunicar servicios, captar prospectos y reforzar la imagen comercial de la empresa.',
    tags: ['Proyecto Real', 'Corporativo'],
    image: vectorImage,
    liveUrl: 'https://vector.com.sv',
    sourceUrl: null,
  },
  {
    title: 'Treearch',
    description: 'Página publicitaria para empresa con enfoque institucional, mensaje de marca claro y estructura orientada a conversión.',
    tags: ['Proyecto Real', 'Institucional'],
    image: treearchImage,
    liveUrl: 'https://treearch.com',
    sourceUrl: null,
  },
  {
    title: 'Sivarco Nosotros',
    description: 'Sección publicitaria e institucional de la empresa Sivarco para presentar su historia, valores y credibilidad de marca.',
    tags: ['Proyecto Real', 'Contenido'],
    image: sivarcoImage,
    liveUrl: 'https://sivarco.com/nosotros',
    sourceUrl: null,
  },
];

const Projects = () => {
  return (
    <section id="projects" className="projects-section">
      <h2>Proyectos Destacados</h2>
      <p className="projects-subtitle">
        Desarrollo soluciones web orientadas a negocio, desde productos propios hasta implementaciones para clientes reales.
      </p>
      <div className="projects-grid">
        {projectData.map((project, index) => (
          <article className="project-card" key={project.title}>
            <div className="project-image">
              {project.image ? (
                <img
                  src={project.image}
                  alt={project.title}
                  loading="lazy"
                  decoding="async"
                  sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              ) : (
                <div className="project-image-fallback">{project.liveUrl.replace('https://', '')}</div>
              )}
            </div>
            <div className="project-info">
              <div className="project-title-row">
                <h3>{project.title}</h3>
                <span className="project-index">#{String(index + 1).padStart(2, '0')}</span>
              </div>
              <p>{project.description}</p>
              <div className="project-tags">
                {project.tags.map((tag) => (
                  <span key={tag} className="tag">{tag}</span>
                ))}
              </div>
            </div>
            <div className="project-links">
              {project.sourceUrl && (
                <a href={project.sourceUrl} target="_blank" rel="noopener noreferrer">
                  Código
                </a>
              )}
              <a href={project.liveUrl} target="_blank" rel="noopener noreferrer">
                Ver Proyecto
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Projects;
